import * as tslib_1 from "tslib";
import { AgmMap } from '@agm/core';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
var OrderLocationsMapComponent = /** @class */ (function () {
    function OrderLocationsMapComponent() {
        this.START_ZOOM = 16;
        this.POLYGON = 'polygon';
        this.managerOptions = {
            drawingMode: null,
            drawingControl: false,
            drawingControlOptions: {
                drawingModes: []
            },
            polygonOptions: {
                draggable: false,
                editable: false,
                strokeColor: '#1b5e20',
                strokeOpacity: 0.6,
                fillColor: '#1b5e20',
                fillOpacity: 0.35
            }
        };
        this.googleMapObjects = [];
    }
    Object.defineProperty(OrderLocationsMapComponent.prototype, "_orderLocations", {
        set: function (orderLocations) {
            if (orderLocations) {
                this.orderLocations = orderLocations;
                this.initLocations();
            }
        },
        enumerable: true,
        configurable: true
    });
    OrderLocationsMapComponent.prototype.initLocations = function () {
        if (this.orderLocations.length === 0) {
            return;
        }
        this.startLatitude = this.orderLocations[0]
            .location.startPoint.lat;
        this.startLongitude = this.orderLocations[0]
            .location.startPoint.long;
        if (!this.map) {
            return;
        }
        this.googleMapObjects.forEach(function (mapObject) {
            mapObject.setMap(null);
        });
        this.googleMapObjects = [];
        this.drawLocations();
    };
    OrderLocationsMapComponent.prototype.onMapReady = function (map) {
        this.map = map;
        this.drawingManager = new google.maps.drawing.DrawingManager(this.managerOptions);
        this.drawingManager.setMap(this.map);
        this.drawLocations();
    };
    OrderLocationsMapComponent.prototype.drawLocations = function () {
        var _this = this;
        this.orderLocations.forEach(function (location, index) {
            return _this.drawLocation(location, index + 1);
        });
    };
    OrderLocationsMapComponent.prototype.drawLocation = function (orderLocation, index) {
        var location = orderLocation.location;
        var points = location.points.map(function (point) { return ({
            lat: point.lat,
            lng: point.long
        }); });
        var polygon = new google.maps.Polygon(tslib_1.__assign({ paths: points, map: this.map }, this.managerOptions.polygonOptions));
        var markerPosition = {
            lat: location.startPoint.lat,
            lng: location.startPoint.long
        };
        var marker = new google.maps.Marker({
            label: "" + index,
            position: markerPosition,
            map: this.map,
            fontSize: 10,
            align: 'center',
            zIndex: 15,
            icon: this.pinSymbol(this.colorForStatus(orderLocation.status))
        });
        this.googleMapObjects.push(polygon);
        this.googleMapObjects.push(marker);
    };
    OrderLocationsMapComponent.prototype.colorForStatus = function (status) {
        switch (status) {
            case TaskLocationStatus.DONE:
                return 'green';
            case TaskLocationStatus.IN_PROGRESS:
                return '#f9a825';
            case TaskLocationStatus.NOT_STARTED:
                return '#dd1f00';
            case TaskLocationStatus.STOPPED:
                return '#4e0aa7';
            default:
                return '#dd1f00';
        }
    };
    OrderLocationsMapComponent.prototype.pinSymbol = function (color) {
        return {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#000',
            strokeWeight: 1,
            scale: 1.4,
            labelOrigin: new google.maps.Point(0, -29)
        };
    };
    return OrderLocationsMapComponent;
}());
export { OrderLocationsMapComponent };
